import {Role} from '../types';

export const rolesMapping = (userRoleCode: number): Role => rolesMap[userRoleCode];

const rolesMap: {[key: number]: Role} = {
  1: Role.REGULAR,
  2: Role.ADMIN,
};
